import { create } from "zustand";
import { SearchSlice, createSearchStore } from "./search.store";

export const useSearchStore = create<SearchSlice>((...args) => ({
	...createSearchStore(...args),
}));
